import React from "react";

export const ShippingTypeColumnFormatter = (cellContent, row) => (
  <span style={{  }}>
      <p style={{ marginBottom:'0' }}>{ cellContent? (cellContent.substring(0, cellContent.lastIndexOf(" "))) : ''  }</p>
      <p style={{ marginBottom:'0' }}>{  cellContent? (cellContent.substring(cellContent.lastIndexOf(" ")+1) ) : '' }</p>
  </span>
);

